module.exports = __webpack_public_path__ + "img/seal.3cd53ca2.png";